import { addHours, addMinutes, getMinutes, isBefore } from "date-fns";

import { parseTime } from "@app/util/parsers";

import EmailSendingWindow from "../types/EmailSendingWindow";

const INTERVAL_MINUTES = 15;

const roundUpTo15Min = (date: Date): Date => {
  const minutes = getMinutes(date);
  const remainder = minutes % INTERVAL_MINUTES;
  return remainder === 0 ? date : addMinutes(date, INTERVAL_MINUTES - remainder);
};

/**
 * Computes the default time for the "Later today" preset.
 * Returns current time + 1hr rounded up to 15min, clamped to sendingWindow start.
 * A startTime of "00:00" naturally means no clamping (midnight is always before rounded).
 */
const getDefaultTodayTime = (sendingWindow: EmailSendingWindow): Date => {
  const rounded = roundUpTo15Min(addHours(new Date(), 1));
  const windowStart = parseTime(sendingWindow.startTime);

  return isBefore(rounded, windowStart) ? windowStart : rounded;
};

export { getDefaultTodayTime, roundUpTo15Min };
